import type { StateCreator } from 'zustand';
import type { BoundStore } from './store.types';

type State = {
	currentSnapPoint: number | null;
};

type Action =
	| { type: 'moveBottomSheet'; snapPoint: number }
	| { type: 'back' }
	| { type: 'clickMarker' };

export const bottomSheetTypes = {
	moveBottomSheet: 'moveBottomSheet',
	back: 'back',
	clickMarker: 'clickMarker',
} as const;

const reducer = (state: State, action: Action): State => {
	switch (action.type) {
		case bottomSheetTypes.moveBottomSheet:
			return { ...state, currentSnapPoint: action.snapPoint };
		case bottomSheetTypes.back:
			return { ...state, currentSnapPoint: 1 };
		case bottomSheetTypes.clickMarker:
			return { ...state, currentSnapPoint: 2 };
	}
};

export type BottomSheetSlice = State & {
	dispatch: (action: Action) => void;
};

const createBottomSheetSlice: StateCreator<
	BoundStore,
	[],
	[],
	BottomSheetSlice
> = (set) => ({
	currentSnapPoint: null,
	dispatch: (action) => set((state) => reducer(state, action)),
});

export default createBottomSheetSlice;
